import { gittMiljo } from '../utils/environment';

export const linkTilMinSideArbeidsgiver = (orgnr: string) => {
    const orgNrDel = orgnr.length > 0 ? '?bedrift=' + orgnr : '';
    return (
        gittMiljo({
            prod: 'https://arbeidsgiver.nav.no/min-side-arbeidsgiver/',
            dev: 'https://arbeidsgiver.intern.dev.nav.no/min-side-arbeidsgiver/',
            other: 'https://arbeidsgiver.ansatt.dev.nav.no/min-side-arbeidsgiver/',
        }) + orgNrDel
    );
};

export const linkTilArbeidsforhold = (orgnr: string) => {
    const orgNrDel = orgnr.length > 0 ? '?bedrift=' + orgnr : '';
    return (
        gittMiljo({
            prod: 'https://arbeidsgiver.nav.no/arbeidsforhold/',
            dev: 'https://arbeidsforhold.intern.dev.nav.no/arbeidsforhold',
            other: 'https://arbeidsforhold.ansatt.dev.nav.no/arbeidsforhold/',
        }) + orgNrDel
    );
};

const delegationRequestUrl = gittMiljo({
    prod: 'https://altinn.no/ui/DelegationRequest',
    other: 'https://tt02.altinn.no/ui/DelegationRequest',
});

export const beOmTilgangIAltinnLink = (
    orgnr: string,
    serviceKode: string,
    serviceEditionKode: string,
    serviceEditionKodeTest?: string
) => {
    const edition = gittMiljo({
        prod: serviceEditionKode,
        other: serviceEditionKodeTest ?? serviceEditionKode,
    });

    return `${delegationRequestUrl}?offeredBy=${orgnr}&resources=${serviceKode}_${edition}`;
};
